import React, { Fragment, useEffect, useState } from "react";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import AuthHeader from "../../Auth/components/AuthHeader";
import { read, store } from "Helpers/LocalStorage";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";
import Grid from "@material-ui/core/Grid";
import MuiButton from "Components/MuiButton/MuiButton";
import showNotify from "Helpers/Notify";
import Translator from "Languages/Utility/Translator";
import PageTitle from "Components/PageTitle/PageTitle";
import { Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import Package from "./walletComponents/Package";
import CustomPay from "./walletComponents/CustomPay";
// import SendIcon from '@mui/icons-material/Send';

function Wallet() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [chargeCredit, setChargeCredit] = useState([]);
  const [dataTime, setDataTime] = useState([]);
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onClickChargeCredit = async (item) => {
    setLoading(true);
    const payId = item.Id;
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: payId,
      };
      const response = await PaymentService.postChargeCredit(data);
      let err = StatusHandler(response);
      const pay = response.data.Value;
      if (!err.isFail) {
        if (pay.IsError === false) {
          store("orderId", pay.Describ);
          window.open(pay.Link, "_self");
        } else if (pay.IsError === true) {
          const bank = pay.Describ;
          showNotify({ text: bank, customClass: "error" });
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const response = await PaymentService.GetRemainTime(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const remainTime = response.data.Value;
          setDataTime(remainTime);
        }
        const responseSaleDefault = await PaymentService.GetChargeCredit(
          params
        );
        let er = StatusHandler(responseSaleDefault);
        if (!er.isFail) {
          const options = responseSaleDefault.data.Value;
          setChargeCredit(options);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id="wallet" />} />
        <div className="top-buttons">
          <Grid className="walletAmount">
            <span>{t("walletBalance")} :</span>
            <p className="normalTitle">{dataTime.Credit?.toLocaleString()}</p>
            <span>{t("moneyUnit")}</span>
          </Grid>
        </div>
      </div>
      <Box className="w-100">
        <TabContext value={value}>
          <Box>
            <TabList onChange={handleChange}>
              <Tab
                icon={<Icons.Layers />}
                label={t("increaseWalletSuggestions")}
                value="1"
              />
              <Tab
                icon={<Icons.Calculator />}
                label={t("customPay")}
                value="2"
              />
            </TabList>
          </Box>
          <TabPanel value="1" className="p-0 m-0 ">
            <Package chargeCredit={chargeCredit} />
          </TabPanel>
          <TabPanel value="2" className="p-0 m-0 ">
            <CustomPay />
          </TabPanel>
        </TabContext>
      </Box>
    </Fragment>
  );
}

export default Wallet;
